<template>
  <div id="app">
    <header>
      <MainNavigation />
      <landing-Header v-show="$route.name=='Home'" />
    </header>
    <main>
      <router-view/>
    </main>
    <footer-standard />
    <cookie-consent />
  </div>
</template>

<script>
import MainNavigation from '@/components/navigation-main.vue'
import LandingHeader from '@/components/landing-header.vue'
import FooterStandard from '@/components/footer-standard.vue'
import CookieConsent from '@/components/cookie-consent.vue'

export default {
  components: {
    MainNavigation,
    LandingHeader,
    FooterStandard,
    CookieConsent,
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    //title: '• listoliby',
    // all titles will be injected into this template
    titleTemplate: '%s • listoliby',
    meta: [
      { charset: 'utf-8' },
      { name: 'title', content: 'listoliby.com – Lists to live by' },
      { name: 'description', content: 'Free printable checklists for all areas of your life.' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' }
    ]
  }
}
</script>

<style>
  @import './assets/styles/mvp.css';
  @import './assets/styles/formulate.css';
  @import './assets/styles/custom.css';
  @import './assets/styles/print.css';

</style>
